const getUpgradePopUpContent = ({ props = {}, upgradeName }) => {

  switch(upgradeName) {

    case 'signature-upgrade':
      props = {
        icon: require('@/assets/images/documents_upgrade.svg'),
        title: 'common.actions.types.document.upgrade_dialog.title',
        subtitle: 'common.actions.types.document.upgrade_dialog.subtitle',
        bullets: [
          'common.actions.types.document.upgrade_dialog.bullet1',
          'common.actions.types.document.upgrade_dialog.bullet2'
        ],
        approveLabel: 'client.upload_documents_dialog.upgrade_cta',
        cancelLabel: 'client.upload_documents_dialog.upgrade_cta',
      }
      break;

    case 'upgrade_social':
      props = {
        icon: require('@/assets/images/upgrade_social.svg'),
        title: 'settings.client_card.upgrade_social_title',
        subtitle: 'settings.client_card.upgrade_social_subtitle',
        bullets: [
          'settings.client_card.upgrade_social_bullet1',
          'settings.client_card.upgrade_social_bullet2',
          'settings.client_card.upgrade_social_bullet3'
        ],
        bottomText: 'settings.client_card.upgrade_social_now',
      }
      break;

  }

  return props;
}

export {
  getUpgradePopUpContent
};
